import { render, staticRenderFns } from "./display-message-modal.vue?vue&type=template&id=3bcb77a1&scoped=true&"
import script from "./display-message-modal.vue?vue&type=script&lang=js&"
export * from "./display-message-modal.vue?vue&type=script&lang=js&"
import style0 from "./display-message-modal.vue?vue&type=style&index=0&id=3bcb77a1&lang=scss&scoped=true&"
import style1 from "./display-message-modal.vue?vue&type=style&index=1&id=3bcb77a1&lang=scss&scoped=true&"
import style2 from "./display-message-modal.vue?vue&type=style&index=2&id=3bcb77a1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bcb77a1",
  null
  
)

export default component.exports
import {QDialog,QCard,QCardSection,QIcon} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QDialog,QCard,QCardSection,QIcon})
